// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2002":"5bc02827","2201":"07c44e17","2741":"84b1970d","6570":"8d46c0eb"}[chunkId] + ".chunk.css";
};